import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Theme } from '@mui/material'
import { SxProps } from '@mui/system'
import React, { ReactNode } from 'react'

import BottomButton from '../common/BottomButton'
import { CustomTypographyVariant } from '../../theme'

import './index.css'

interface ModalProps {
  showModal: boolean
  hideModal: () => void
  actionButtons?: ReactNode
  closeButton?: boolean
  imageUrl?: string
  img?: ReactNode
  title?: string | ReactNode
  titleVariant?: CustomTypographyVariant
  text?: ReactNode
  subtitle?: string
  isCustomText?: boolean
  textVariant?: CustomTypographyVariant
  textStyles?: SxProps<Theme>
  customPaperStyles?: Record<string, any>
}

const Modal = ({
  showModal,
  hideModal,
  actionButtons = <></>,
  closeButton = false,
  imageUrl = '',
  img = '',
  title = '',
  titleVariant = 'h1',
  text = '',
  subtitle = '',
  isCustomText = false,
  textVariant = 'body2',
  textStyles = {},
  customPaperStyles = {},
}: ModalProps) => {
  return (
    <Dialog
      open={showModal}
      onClose={hideModal}
      maxWidth="xs"
      sx={styles.dialog(customPaperStyles)}
    >
      {closeButton && (
        <div className="modalCloseButton">
          <img src="/images/modalCloseButton.png" onClick={hideModal} />
        </div>
      )}
      {imageUrl && <img className="modalImage" src={imageUrl} />}
      {img}
      {title && (
        <DialogTitle variant={titleVariant || 'h1'} sx={styles.title}>
          {title}
        </DialogTitle>
      )}
      {subtitle && (
        <Typography sx={styles.headlineText} variant="body2">
          {subtitle}
        </Typography>
      )}
      {text &&
        (isCustomText ? (
          text
        ) : (
          <DialogContent>
            <Typography variant={textVariant || 'body2'} sx={{ ...styles.text, ...textStyles }}>
              {text}
            </Typography>
          </DialogContent>
        ))}
      <DialogActions sx={styles.actions}>
        {actionButtons ?? (
          <BottomButton handleClick={hideModal} style={styles.closeButton}>
            Close
          </BottomButton>
        )}
      </DialogActions>
    </Dialog>
  )
}

const styles = {
  cross: {
    position: 'absolute',
    right: 8,
    top: 8,
    color: (theme: Theme) => theme.palette.grey[500],
  },
  text: {
    textAlign: 'left',
    strong: {
      fontWeight: 600,
    },
  },
  closeButton: {
    border: '2px solid rgb(251, 146, 60)',
    backgroundColor: '#ffffff',
    color: '#000000',
    maxWidth: '50%',
  },
  actions: {
    padding: '0 20px 20px',
  },
  title: {
    textAlign: 'center',
  },
  headlineText: {
    fontWeight: 600,
    color: '#0F172A',
    fontSize: {
      xs: '16px',
    },
    textAlign: 'center',
  },
  dialog: (customPaperStyles: Record<string, any>) => ({
    '& .MuiDialog-paper': {
      borderRadius: '16px',
      margin: '21px',
      position: 'relative',
      ...customPaperStyles,
    },
  }),
} as const

export default Modal
